import { Component, Input, OnChanges, SimpleChanges, OnInit} from '@angular/core';
import { NgFor, NgStyle } from '@angular/common';
import { DecimalPipe, CommonModule, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
interface GraphData {
  name: string;
  percentage: number;
  fill: string;
}

@Component({
  selector: 'app-payroll-info',
  standalone: true,
  imports: [CommonModule, DecimalPipe, DatePipe],
  templateUrl: './payroll-info.component.html',
  styleUrls: ['./payroll-info.component.css']
})
export class PayrollInfoComponent implements OnChanges, OnInit {
  @Input() title = '';
  @Input() data: GraphData[] = [];
  @Input() isStar!: boolean;
  @Input() salaries: any[] = [];
  @Input() isLoading = true;
  @Input() userSalaryUpcoming: any;
  @Input() lastSalary: any;

 constructor(private router: Router) {}
   ngOnInit(): void {
    // Simulate API loading
   

    // Replace with actual API
    // this.payrollService.getPayroll().subscribe(data => {
    //   this.payrollData = data;
    //   this.isLoading = false;
    // });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isStar']) {
      console.log('isStar changed in child:', this.isStar);
    }
    if (changes['salaries']) {
      console.log('Received salaries from parent:', this.salaries);
      
    }
  }
   goToPayrollList() {
    this.router.navigate(['/payroll-list']);
  }

 showSlip(data: any) {
      this.router.navigate(['/payroll-sheet'], {
      queryParams: { data: JSON.stringify(data) },
      skipLocationChange: true,
    });
  }
  loanreq() {
      this.router.navigate(['/payroll'], { queryParams: { fromLoanRequest: true } })
  }
}
